import { render } from "./APropos.vue?vue&type=template&id=86c12f98&scoped=true"
import script from "./APropos.vue?vue&type=script&lang=js"
export * from "./APropos.vue?vue&type=script&lang=js"

import "./APropos.vue?vue&type=style&index=0&id=86c12f98&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c12f98"]])

export default __exports__